import React, { Fragment, useState } from "react";
import { Button } from "primereact/button";

import Translate from "Components/Translate";

import { CREATE_BOOKING } from "Constant";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import CreateBooking from "Common/CreateBooking";

const CreateBookingBtn = () => {
  const [open, setOpen] = useState(false);
  const onCreate = () => {
    setOpen((prevState) => !prevState);
  };
  return (
    <Fragment>
      <Button
        onClick={onCreate}
        icon="pi pi-plus-circle"
        label={<Translate>{CREATE_BOOKING}</Translate>}
        severity="success"
        raised
      />
      <Modal
        isOpen={open}
        toggle={onCreate}
        size="xl"
        fullscreen={true}
        //style={{ maxHeight: "90vh", overflowY: "auto" }}
        centered
        backdrop="static"
        keyboard={false}
      >
        <ModalHeader toggle={onCreate}>
          <Translate>{CREATE_BOOKING}</Translate>
        </ModalHeader>
        <ModalBody>
          <CreateBooking />
        </ModalBody>
      </Modal>
    </Fragment>
  );
};

export default CreateBookingBtn;
